import { render } from "./Artistdetail.vue?vue&type=template&id=36c2a522&scoped=true"
import script from "./Artistdetail.vue?vue&type=script&lang=js"
export * from "./Artistdetail.vue?vue&type=script&lang=js"

import "./Artistdetail.vue?vue&type=style&index=0&id=36c2a522&scoped=true&lang=css"
import "./Artistdetail.vue?vue&type=style&index=1&id=36c2a522&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-36c2a522"

export default script